import Sortable from 'sortablejs';

const checkboxNodes = document.querySelectorAll( '.wcbt-checkbox-content-wrapper.wcbt-sortable' );

const wcbtCheckboxSortable = () => {
	if ( ! checkboxNodes ) {
		return;
	}
	for ( let i = 0; i < checkboxNodes.length; i++ ) {
		const checkboxNode = checkboxNodes[ i ];
		Sortable.create( checkboxNode, {
			handle: '.wcbt-checkbox-content span', animation: 150,
			onEnd() {
				reindexCheckbox( checkboxNode );
			},
		} );
	}
};

const reindexCheckbox = ( checkboxNode ) => {
	let value = '';
	checkboxNode.querySelectorAll( '.wcbt-checkbox-content' ).forEach( function( checkboxContentNode ) {
		checkboxContentNode.querySelectorAll( 'input[type="checkbox"]' ).forEach( function( inputNode ) {
			value += inputNode.value + ',';
		} );
	} );
	value = value.slice( 0, -1 );

	checkboxNode.querySelector( ':scope > input[type=hidden]' ).value = value;
};

export default wcbtCheckboxSortable;
